import React, { memo, useMemo } from 'react'
import { TableCell } from 'transfix-ui/components/Table'
import { Typography } from 'transfix-ui/core'
import { LaneAlert } from 'apps/marketplace/apiTypes/carrierLaneAlerts'
import { formatLane } from './utils'

interface ISavedLanesTableLanePreferenceCellProps
  extends Pick<
    LaneAlert,
    | 'id'
    | 'deliveryCity'
    | 'deliveryMiles'
    | 'deliveryStateCode'
    | 'pickupCity'
    | 'pickupMiles'
    | 'pickupStateCode'
  > {}

export const SavedLanesTableLanePreferenceCell = memo(
  ({
    deliveryCity,
    deliveryMiles,
    deliveryStateCode,
    id,
    pickupCity,
    pickupMiles,
    pickupStateCode,
  }: ISavedLanesTableLanePreferenceCellProps) => {
    const pickup = useMemo(() => {
      return formatLane({ city: pickupCity, stateCode: pickupStateCode, radius: pickupMiles })
    }, [pickupCity, pickupMiles, pickupStateCode])

    const delivery = useMemo(() => {
      if (!deliveryCity && !deliveryStateCode) {
        return 'Any Dropoff'
      }

      return formatLane({ city: deliveryCity, stateCode: deliveryStateCode, radius: deliveryMiles })
    }, [deliveryCity, deliveryMiles, deliveryStateCode])

    return (
      <TableCell dataTest={`saved-lane-${id}-lane-preference`}>
        <Typography variant='body2'>{`${pickup} – ${delivery}`}</Typography>
      </TableCell>
    )
  }
)
